import { ApiBlueprint, createFrontendPlugin, discoveryApiRef, fetchApiRef, PageBlueprint } from '@backstage/frontend-plugin-api';
import { citymapApiRef, CitymapClient } from './api';
import { rootRouteRef } from './routes';

const citymapApi = ApiBlueprint.make({
  params: defineParams => 
    defineParams({
      api: citymapApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CitymapClient({ fetchApi, discoveryApi }),
    }),
});

const citymapPage = PageBlueprint.make({
  params: {
    path: '/citymap',
    title: 'Citymap',
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/CitymapPage').then(m => <m.CitymapPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'citymap',
  extensions: [
    citymapApi,
    citymapPage,
  ],
  routes: {
    root: rootRouteRef,
  },
});